import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { CipherSection } from '@/components/cipher'

const Home: FC = (): ReactNode => {
    return (
        <>
            <Seo />

            <main>
                <CipherSection />
            </main>
        </>
    )
}

export default Home
